import React, { } from 'react'
import styles from './ChangeLog.module.css'
import { convertDateTimeToApplicationTime } from '../../../util/functions'

const ChangeLog = (props) => {

    const changeLogDate = new Date(props.date)
    return <>
        <div className={styles['changelog-title']}>
            <div className={styles['title-body-container']}>
                <i className={`fa-regular fa-clipboard ${styles['title-icon']}`}></i>
                <h2 className={`${styles['title-desc']}`}>{props.title} </h2>
            </div>
            <p className={`${styles['title-date']}`}>  -  {convertDateTimeToApplicationTime(changeLogDate)}</p>
        </div>
        <p className={styles['log-body']}>
            {props.children}
        </p>
    </>
}

export default ChangeLog